module.exports = __webpack_public_path__ + "static/media/cardholdername.db823eec.svg";